<template>
  <div class="p-4">
    <l-container>
      <l-container-title
        slot="toolbar"
        :loading="loading"
        text="Export"
        icon="file-export"
        color="bg-blue-400"
      />
      <div class="w-full flex flex-col">
        <div class="flex mt-4">
          <div class="w-1/3 p-2">
            <label class="block text-grey-darker text-sm font-bold mb-2" for="year">Year</label>
            <l-input v-model="year" id="year" type="number" placeholder />
          </div>
          <div class="w-1/3 p-2">
            <label class="block text-grey-darker text-sm font-bold mb-2" for="tz">Timezone</label>
            <l-input v-model="tz" id="tz" type="number" placeholder />
          </div>
          <div class="w-1/3 p-2">
            <label class="block text-grey-darker text-sm font-bold mb-2" for="tz">Description</label>
            <l-input v-model="description" id="desc" type="text" placeholder />
          </div>
        </div>

        <div class="flex mt-4">
          <div class="m-2">
            <l-button type="success" size="md" class="mr-4" @click="downloadB">Download dataflow B</l-button>
          </div>
          <div class="m-2">
            <l-button type="success" size="md" class="mr-4" @click="downloadD">Download dataflow D</l-button>
          </div>
          <div class="m-2">
            <l-button type="success" size="md" class="mr-4" @click="downloadE1a">Download dataflow E1A</l-button>
          </div>
          <div class="m-2">
            <l-button type="success" size="md" class="mr-4" @click="downloadC">Download dataflow C</l-button>
          </div>
          <div class="m-2">
            <l-button type="success" size="md" class="mr-4" @click="downloadG">Download dataflow G</l-button>
          </div>
        </div>
      </div>
    </l-container>
    <div class="w-full flex flex-col">
      <div class="flex align-baseline"></div>
    </div>
    <div class="w-full flex flex-col"></div>
  </div>
</template>

<script>
import ExportService from "./export.service";
import { LButton } from "@/components/forms";
import { LInput } from "@/components/forms";
import { LRadio } from "@/components/forms";
import Notify from "@/helpers/notify";
import FileDownload from "js-file-download";

export default {
  name: "Approval",
  components: {
    LButton,
    LInput
  },
  data() {
    return {
      loading: false,
      year: new Date().getFullYear(),  //- 1,
      tz: 1,
      description: "Update"
    };
  },
  mounted() {
    var self = this;
  },

  methods: {
    async downloadB() {
      await Notify.loadData(
        "Please wait while generating XML file for dataflow B",
        async () => {
          const results = await ExportService.getDataflowB(
            this.year,
            this.tz,
            this.description)
            Notify.success("XML for Dataflow B generated successfully!");
            FileDownload(results, "dataflow_b.xml")
        }
      );
    },
    async downloadD() {
      await Notify.loadData(
        "Please wait while generating XML file for dataflow D",
        async () => {
          const results = await ExportService.getDataflowD(
            this.year,
            this.tz,
            this.description)
            Notify.success("XML for Dataflow D generated successfully!");
            FileDownload(results, "dataflow_D.xml")
        }
      );
    },
    async downloadC() {
      debugger;
      await Notify.loadData(
        "Please wait while generating XML file for dataflow C",
        async () => {
          const results = await ExportService.getDataflowC(
            this.year,
            this.tz,
            this.description)
            Notify.success("XML for Dataflow C generated successfully!");
            FileDownload(results, "dataflow_c.xml")
        }
      );
    },
    async downloadG() {
      debugger;
      await Notify.loadData(
        "Please wait while generating XML file for dataflow G",
        async () => {
          const results = await ExportService.getDataflowG(
            this.year,
            this.tz,
            this.description)
            Notify.success("XML for Dataflow G generated successfully!");
            FileDownload(results, "dataflow_g.xml")
        }
      );
    },
    async downloadE1a() {
      debugger;
      await Notify.loadData(
        "Please wait while generating XML file for dataflow E1a",
        async () => {
          const results = await ExportService.getDataFlowE1A(
            this.year,
            this.tz,
            this.description)
            Notify.success("XML for Dataflow E1a generated successfully!");
            FileDownload(results, "dataflow_e1a.xml")
        }
      );
    }
      
  }
  
};
</script>

<style lang="postcss">
</style>

